/** Remaining balances are whole credits. Millicredits stay in the ledger. */

export function wholeCredits(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.round(n));
}

export function formatCreditBalance(value) {
  return wholeCredits(value).toLocaleString();
}

/**
 * The full-turn estimate and initial hold are independent. File tool rounds
 * can cost more than the amount required to start the first model call.
 */
export function resolveComposerCreditQuote(estimate, hold) {
  const estimated = Number.isFinite(Number(estimate)) ? Math.max(0, Number(estimate)) : 0;
  const hasHold = hold != null && Number.isFinite(Number(hold));
  const reserved = hasHold ? Math.max(0, Number(hold)) : estimated;
  return {
    estimated,
    reserved,
    hasHold: hasHold && reserved > 0,
  };
}

export function composerCreditCalculation(cost) {
  return {
    cost: cost?.estimatedTotal ?? (cost?.variableBilling ? cost?.authorizationTotal : cost?.total)
      ?? cost?.total ?? cost?.authorizationTotal ?? null,
    authorizationCost: cost?.authorizationTotal ?? cost?.total ?? null,
    variableBilling: !!cost?.variableBilling,
    fileEstimate: !!cost?.fileEstimate,
  };
}

/**
 * Rewrite millicredit / float-error amounts in user-facing copy so a stored
 * ask_user card never shows 43653.797770700001.
 */
export function formatCreditsInText(text) {
  return String(text ?? '').replace(
    /\d+\.\d+(?=\s*credits\b)|\d+\.\d{3,}/gi,
    (raw) => formatCreditBalance(raw),
  );
}
